import { Box, Chip, Divider, FormLabel, Grid } from '@mui/material';

import BoyIcon from '@mui/icons-material/Boy';
import GirlIcon from '@mui/icons-material/Girl';
import CakeIcon from '@mui/icons-material/Cake';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import CallIcon from '@mui/icons-material/Call';
import AadharIcon from "../../assets/aadhaar.svg";
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import Diversity1Icon from '@mui/icons-material/Diversity1';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

import useDisplayDate from '../../hooks/Date/useDisplayDate';

const CustomerInformation = ({custdata}) =>{
    const {formatDate } = useDisplayDate();

    return (
             <>
                                <Divider>
                                          <Chip label={custdata?.comp + ' - ' + custdata?.customerID + ' - ' + custdata?.name} 
                                          size="small" 
                                          className={custdata?.gender === "Male" ? "bg-446493 text-white" : "bg-FFC0CB text-white"}
                                        //   sx={{backgroundColor: custdata?.gender === "Male" ? "primary.main" : "",color: custdata?.gender === "Male" ? "white" : ""}}
                                          />
                                </Divider>
                                  
                                <Box sx={{mt:1}}>
                                  
                                      {/* <Typography variant="label" component="label">
                                        <CakeIcon />
                                     </Typography>
                                      <Typography variant="span" component="span" sx={{ml: 2}}>
                                               {formatDate(custdata?.dob)}
                                      </Typography>

                                     <Typography variant="label" component="label">
                                        Date Of Birth
                                     </Typography>
                                      <Typography variant="span" component="span" sx={{ml: 2}}>
                                               {formatDate(custdata?.dob)}
                                      </Typography> */}

                                      <Grid container spacing={{ xs: 1, sm: 2 }} columns={{ xs: 6, sm: 12 }}>
                                            

                                          {custdata?.email &&
                                            <Grid  size={{ xs: 12, sm: 6}}>
                                              <Box sx={{ display: 'flex' }}>
                                                <FormLabel sx={{ mr: 1 }}>
                                                     <MailOutlineIcon color='primary'  />
                                                </FormLabel>
                                                {/* <Typography variant="label" component="label">
                                                     <MailOutlineIcon color='primary' sx={{ mr: 1 }} />
                                                </Typography> */}
                                                <Box 
                                                component="a"
                                                href={`mailto:${custdata?.email}`}
                                                sx={{
                                                  color: 'primary.main',
                                                  textDecoration: 'none',
                                                  cursor: 'pointer',
                                                  '&:hover': { textDecoration: 'underline' }
                                                }}
                                                >
                                                   {custdata?.email}
                                                </Box>
                                              </Box>
                                            </Grid>
                                          }

                                          {custdata?.mobile &&
                                            <Grid size={{ xs: 12, sm: 6}}>
                                              <Box sx={{ display: 'flex' }}>
                                                <FormLabel sx={{ mr: 1 }}>
                                                     <CallIcon color='secondary' />
                                                </FormLabel>
                                                <Box
                                                  component="a"
                                                  href={`tel:${custdata?.mobile}`}
                                                  sx={{
                                                    color: 'primary.main',
                                                    textDecoration: 'none',
                                                    cursor: 'pointer',
                                                    '&:hover': { textDecoration: 'underline' }
                                                  }}
                                                >
                                                          {custdata?.mobile}
                                                </Box>
                                              </Box>
                                            </Grid>
                                          }

                                          {custdata?.aadharNo && 
                                            <Grid size={{ xs: 12, sm: 6}}>
                                              <Box sx={{ display: 'flex' }}>
                                                  <FormLabel sx={{ mr: 1 }}>
                                                    
                                                         <Box
                                                            component="img"
                                                            srcSet={AadharIcon}
                                                            src={AadharIcon}
                                                            alt="aadhar svg"
                                                            loading="lazy"
                                                            sx={{ width: 30, height: 24 }}
                                                          />
                                                  </FormLabel>
                                                <Box >
                                                  {custdata?.aadharNo}
                                                </Box>
                                              </Box>
                                            </Grid>
                                          }

                                          {custdata?.pancard  &&
                                            <Grid size={{ xs: 12, sm: 6}}>
                                              <Box sx={{ display: 'flex' }}>
                                                <FormLabel sx={{ mr: 1 }}>
                                                  <FingerprintIcon color='primary' />
                                                </FormLabel>
                                                <Box>
                                                  {custdata?.pancard}
                                                </Box>
                                              </Box>
                                            </Grid>
                                          }

                                          {custdata?.marrital &&
                                            <Grid size={{ xs: 12, sm: 6}}>
                                              <Box sx={{ display: 'flex' }}>
                                                <FormLabel sx={{ mr: 1 }}>
                                                  <Diversity1Icon color='primary' />
                                                </FormLabel>
                                                <Box>
                                                  {custdata?.marrital}
                                                </Box>
                                              </Box>
                                            </Grid>
                                          }


                                          {custdata?.employeeType &&
                                            <Grid size={{ xs: 12, sm: 6}}>
                                              <Box sx={{ display: 'flex' }}>
                                                <FormLabel sx={{ mr: 1 }}>
                                                  <CurrencyRupeeIcon color='secondary' />
                                                </FormLabel>
                                                <Box>
                                                  {custdata?.employeeType}
                                                </Box>
                                              </Box>
                                            </Grid>
                                          }


                                          {custdata?.gender &&
                                            <Grid size={{ xs: 12, sm: 6}}>
                                              <Box sx={{ display: 'flex' }}>
                                                <FormLabel sx={{ mr: 1 }}>
                                                     {custdata?.gender === "Male" ? <BoyIcon color='primary'/>  : <GirlIcon className='text-FFC0CB'/>}
                                                </FormLabel>
                                                <Box>
                                                  {custdata?.gender}
                                                </Box>
                                              </Box>
                                            </Grid>
                                          }

                                          {custdata?.dob &&
                                            <Grid size={{ xs: 12, sm: 6}}>
                                              <Box sx={{ display: 'flex' }}>
                                                <FormLabel sx={{ mr: 1 }}>
                                                     <CakeIcon color='primary'/>
                                                </FormLabel>
                                                <Box>
                                                  {formatDate(custdata?.dob)}
                                                </Box>
                                              </Box>
                                            </Grid>
                                          }
                                      </Grid>
                                </Box>
             
             </>
    )
}

export default CustomerInformation